// src/components/Explore/filters/FilterPill.jsx
// Active filter pill with remove button

import React from 'react';
import { FaTimes } from 'react-icons/fa';
import styles from './FilterPill.module.css';

const FilterPill = ({ label, onRemove, icon: Icon }) => {
  return (
    <div className={styles.filterPill}>
      {Icon && <Icon className={styles.icon} />}
      <span className={styles.label}>{label}</span>
      <button
        type="button"
        className={styles.removeButton}
        onClick={onRemove}
        aria-label={`Remove ${label} filter`}
      >
        <FaTimes />
      </button>
    </div>
  );
};

export default FilterPill;










